import authRestService from '../services/authorization/AuthRestService'
import { hasPermission, hasAny, homeFor } from '../services/authorization/ModuleAccess'

let profileRequest = null
const fieldworkReads = ['fieldwork.records.read', 'fieldwork.machinery.read', 'fieldwork.prices.read', 'fieldwork.reports.read']
const inventoryReads = ['inventory.catalogs.read', 'inventory.items.read', 'inventory.assets.read', 'inventory.stock.read', 'inventory.documents.read']
const plantReads = ['plant.home.read', 'plant.incomes.read', 'plant.processes.read', 'plant.outcomes.read']
const isFieldworkOnly = state => hasAny(state.userProfile, fieldworkReads) && !hasAny(state.userProfile, plantReads)

const state = {
  isAuthenticated: false,
  sessionInitialized: false,
  userProfile: {
    name: '',
    id: null,
    roles: [],
    permissions: [],
    authorizationRevision: 0
  }
}
const getters = {
  isAuthenticated: state => state.isAuthenticated,
  hasPermission: state => permission => hasPermission(state.userProfile, permission),
  hasAnyPermission: state => permissions => hasAny(state.userProfile, permissions),
  canReadFieldwork: state => hasAny(state.userProfile, fieldworkReads),
  canManageFieldwork: state => hasAny(state.userProfile, ['fieldwork.records.create', 'fieldwork.records.update', 'fieldwork.records.confirm', 'fieldwork.records.correct', 'fieldwork.machinery.create', 'fieldwork.machinery.update', 'fieldwork.prices.create']),
  canExportFieldwork: state => hasPermission(state.userProfile, 'fieldwork.reports.export'),
  isFieldworkOnly,
  canManageSharedCatalogs: state => hasAny(state.userProfile, ['catalog.companies.create', 'catalog.companies.update', 'catalog.companies.delete', 'catalog.locations.create', 'catalog.locations.update', 'catalog.locations.delete', 'catalog.lots.create', 'catalog.lots.update', 'catalog.lots.delete']),
  canReadPlant: state => hasAny(state.userProfile, plantReads),
  canReadAgrochemicals: state => hasAny(state.userProfile, ['agrochemicals.products.read', 'agrochemicals.withdrawals.read', 'agrochemicals.applications.read']),
  canReadInventory: state => hasAny(state.userProfile, inventoryReads),
  canImportInventory: state => hasPermission(state.userProfile, 'inventory.catalog.import'),
  homeRoute: state => homeFor(state.userProfile),
  authorizationRevision: state => state.userProfile.authorizationRevision
}
const actions = {
  async logout (context) {
    try {
      await authRestService.logout()
    } catch (error) {
      console.log('error loggin out ', error)
    } finally {
      context.commit('logout')
    }
  },
  async login (context, credentials) {
    let session = await authRestService.login(credentials)
    context.commit('login')
    context.commit('setUserInfo', session.user)
    return session
  },
  async validate (context) {
    if (profileRequest) return profileRequest
    profileRequest = (async () => {
    try {
      let session = await authRestService.validate()
      if (session.authenticated) {
        context.commit('login')
        context.commit('setUserInfo', session.user)
      } else {
        context.commit('logout')
      }
    } catch (error) {
      if (error.response?.status === 401) context.commit('logout')
      else context.commit('sessionChecked')
      throw error
    } finally {
      profileRequest = null
    }
    })()
    return profileRequest
  }
}
const mutations = {
  logout (state) {
    state.sessionInitialized = true
    state.isAuthenticated = false
    state.userProfile.name = ''
    state.userProfile.id = null
    state.userProfile.roles = []
    state.userProfile.permissions = []
    state.userProfile.authorizationRevision = 0
  },
  login (state) {
    state.sessionInitialized = true
    state.isAuthenticated = true
  },
  setUserInfo (state, userInfo) {
    if ((userInfo.authorizationRevision || 0) < state.userProfile.authorizationRevision) return
    state.userProfile.id = userInfo.id
    state.userProfile.name = userInfo.username
    state.userProfile.roles = userInfo.roles || []
    state.userProfile.permissions = userInfo.permissions || []
    state.userProfile.authorizationRevision = userInfo.authorizationRevision || 0
  },
  sessionChecked (state) {
    state.sessionInitialized = true
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
